import { render, staticRenderFns } from "./IconSvgHome.vue?vue&type=template&id=4f3d9273&scoped=true&"
import script from "./IconSvgHome.vue?vue&type=script&lang=js&"
export * from "./IconSvgHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d9273",
  null
  
)

export default component.exports